import type { FaireThemeEntity } from "../../entity_types/theme";

export const clean_living_and_holistic_care: FaireThemeEntity = {
  token: "clean-living-and-holistic-care",
  type: "theme",
  name: "Clean Living & Holistic Care",
  description: "Stock up on nutrient-dense staples and natural remedies that prioritize total-body wellness. These artisanal goods align with your commitment to non-toxic, high-quality ingredients.",
  teaser: "Your profile shows a strong dedication to holistic health, with frequent orders of essential oils, healing salves, and lymphatic lotions. You consistently prioritize 'clean,' 'organic,' and 'plant-based' product signals.",
  detail: "The inclusion of Regenerative Chicken Bone Broth in your open cart demonstrates a continued interest in high-quality, health-conscious products that fit your wellness-heavy inventory.",
  bgColor: "#D4E6F1",
  tileBgColor: "#3b6b3b",
  exactProducts: true,
  retailerToken: "r_vywa5ks4ga",
  productTokens: [
    "p_ekm444zk35",
    "p_ev6grga8gh",
    "p_v9vh5q5drf",
    "p_958mj3kbr6",
    "p_9uqwm7u2k3",
    "p_2qcw8mc5sn",
    "p_56gsj9wwdx",
    "p_s9vkfcbt95",
    "p_7ymhkqkhmb",
    "p_vz2qescxw7",
    "p_77kp5x4scg",
    "p_r9pg9jnujm",
    "p_6y246qhmj6",
    "p_gt8crrbsqr",
    "p_eay9k97q29",
    "p_dwxvfq6kf7",
    "p_93tgcbezxs",
    "p_6mefxkxphy",
    "p_3swnkt8tya",
    "p_6lbg51g67p",
    "p_t3dngtatcj",
    "p_326x2kvahq",
    "p_y6gzp57az6",
    "p_3sxuxp5mdh",
    "p_cbhp68psak",
    "p_8ny4cbex9w",
    "p_svcamt9d3f",
    "p_9s2fenn8bp",
    "p_29v63xzs7f",
    "p_atzvr48lkf",
    "p_gt2rsb3wmb",
    "p_ggryz8hkzv",
    "p_xdzsz9bj9t",
    "p_rd3pw7jrvx",
    "p_k23tx4c6vs",
    "p_srxcxwxusc",
    "p_c78uqr7stc",
    "p_yyhju65key",
    "p_4sb3cxcgbq",
    "p_jsqxh3zbaa",
  ],
  meta: {
    source: "mock",
    importedAt: "2026-03-26T00:00:00Z",
    importedBy: "manual-v3-import",
  },
};
